'use client';

import { ACCOUNT_COPY } from '@eliadmin/core/src/components/dlz/account/account-copy';
import { AccountHeading } from '@eliadmin/core/src/components/dlz/account/account-heading';
import { ForgotPasswordCard } from '@eliadmin/core/src/components/dlz/account/password/forgot-password-card';
import { PasswordForm } from '@eliadmin/core/src/components/dlz/account/password/password-form';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';

/**
 * „Zmena hesla“ (Figma 60322:19374, mobile 60459:89796): heading, then „Row“ (60322:19899) – the
 * password card beside the 314 px „Info“ column once the content column has room (720 px and more),
 * stacked otherwise. The designed „Zabezpečenie účtu“ card (last password change, last sign-in) is
 * left out: the customer record has neither.
 */
export function PasswordView() {
  const me = useCustomerStore(s => s.me);
  if (!me) return null;

  return (
    <div className="flex flex-col gap-6 @container">
      <AccountHeading
        title={ACCOUNT_COPY.pages.password.label}
        description={ACCOUNT_COPY.pages.password.description}
      />
      <div className="flex flex-col gap-4 @[45rem]:flex-row @[45rem]:items-start @[45rem]:gap-6">
        <PasswordForm
          email={me.customer.email}
          authToken={me.authToken}
          className="@[45rem]:min-w-0 @[45rem]:flex-1"
        />
        <aside className="@[45rem]:w-[314px] @[45rem]:shrink-0">
          <ForgotPasswordCard email={me.customer.email} />
        </aside>
      </div>
    </div>
  );
}
